import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { iframeUrl } from 'src/app/core/constant/iframeUrls';

@Component({
  selector: 'app-create-entity-agent',
  templateUrl: './create-entity-agent.component.html',
  styleUrls: ['./create-entity-agent.component.scss']
})
export class CreateEntityAgentComponent implements OnInit {
  iframeUrlCreateEntityAgent: any;

  constructor(
    private sanitizer: DomSanitizer,
    private router: Router,
  ) {

  }

  ngOnInit(): void {
    let iframeUrlCreateEntityAgentRaw = iframeUrl.createAgent.url;
    this.iframeUrlCreateEntityAgent = this.sanitizer.bypassSecurityTrustResourceUrl(iframeUrlCreateEntityAgentRaw);
  }

  BackToDashboard() {
    this.router.navigate(['dashboard']);
  }
}
